import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "subtitle", "actions", "children"];
import React from 'react';
import theme from '../theme.config';
import EzCardHeading from './EzCardHeading';
import { EzContent, EzHeader } from '../EzContent';
var spacing = theme.css({
  '&& > * + *': {
    marginTop: '$card-content-gap'
  }
});
var EzCardSection = function EzCardSection(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    actions = _ref.actions,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var content = React.createElement(EzContent, spacing(props).props, children);
  return React.createElement(React.Fragment, null, !title ? content : React.createElement("section", null, React.createElement(EzHeader, null, React.createElement(EzCardHeading, {
    actions: actions,
    title: title,
    subtitle: subtitle
  })), content));
};
EzCardSection.displayName = 'EzCardSection';
export default EzCardSection;